import { render, staticRenderFns } from "./PdpInfoOeLink.vue?vue&type=template&id=654ff60d&scoped=true"
import script from "./PdpInfoOeLink.vue?vue&type=script&lang=js"
export * from "./PdpInfoOeLink.vue?vue&type=script&lang=js"
import style0 from "./PdpInfoOeLink.vue?vue&type=style&index=0&id=654ff60d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654ff60d",
  null
  
)

/* custom blocks */
import block0 from "../translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F02-molecules%2Fproduct-info-sections%2Fsubcomponents%2FPdpInfoOeLink.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports